import firebase from "firebase/app";
import "firebase/storage";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API,
  authDomain: process.env.REACT_APP_AUTH,
  projectId: process.env.REACT_APP_ID,
  storageBucket: process.env.REACT_APP_BUCKET,
  messagingSenderId: process.env.REACT_APP_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

//   initizlize
firebase.initializeApp(firebaseConfig);

export const fireStorage = firebase.storage();
export const fireDb = firebase.firestore();
export const timestamp = firebase.firestore.FieldValue.serverTimestamp;
